import { Message } from "@ai-sdk/react"

export const convertHtmlToMarkdown = (html: string): string => {
  try {
    const parser = new DOMParser()
    const doc = parser.parseFromString(html, "text/html")
    return doc.body.textContent || ""
  } catch (error) {
    return ""
  }
}

export const formatAsMarkdown = (message: Message): string => {
  if (message.parts && message.parts.length > 0) {
    return convertHtmlToMarkdown(
      message.parts
        .filter(part => part.type === "text")
        .map(part => part.text)
        .join("\n\n"),
    )
  }

  return convertHtmlToMarkdown(message.content || "")
}
